import useStudentPreChecks from "../../useStudentPreChecks";

export default function useControlledSpeech({speechProps}) {
    
    const studentPreCheck = useStudentPreChecks({})
    const {settings} = studentPreCheck

    const speakWith = async ({doBeforeSpeak, speak, doAfterSpeak}) => {

        if(doBeforeSpeak){
            if(doBeforeSpeak.forFTUE && settings.shouldGoThroughFTUE){
                await doBeforeSpeak.forFTUE()
            }else if(doBeforeSpeak.forReturningUserWithAssessment && settings.shouldDoAudioChecks){
                await doBeforeSpeak.forReturningUserWithAssessment()
            }else if(doBeforeSpeak.forReturningUser){
                await doBeforeSpeak.forReturningUser()
            }
        }

        if(speak){
            if(settings.shouldGoThroughFTUE){
                if(speak.forFTUE) await speechProps.speakWithPromise({textToSpeak: speak.forFTUE})
            }else if(settings.shouldDoAudioChecks){
                if(speak.forReturningUserWithAssessment) await speechProps.speakWithPromise({textToSpeak: speak.forReturningUserWithAssessment})
            }else{
                if(speak.forReturningUser) await speechProps.speakWithPromise({textToSpeak: speak.forReturningUser})
            }
        }
        
        if(doAfterSpeak){
            if(doAfterSpeak.forFTUE && settings.shouldGoThroughFTUE){
                await doAfterSpeak.forFTUE()
            }else if(doAfterSpeak.forReturningUserWithAssessment && settings.shouldDoAudioChecks){
                await doAfterSpeak.forReturningUserWithAssessment()
            }else if(doAfterSpeak.forReturningUser){
                await doAfterSpeak.forReturningUser()
            }
        }
    }

    return {
        speakWith
    }
}
